import {
	ON_CLICK_DETAILS_FAIL,
	ON_CLICK_DETAILS_START,
	ON_CLICK_DETAILS_SUCCESS,
} from "./actions/ActionTypes";

export const initAutomationState = () => {
	return {
		loadingOnClick: true,
		errorOnClick: "",
		operatorOnClick: "",
	}
}

export const AUTOMATION_INITIAL_STATE = {}

export const AutomationReducer = (state = AUTOMATION_INITIAL_STATE, action) => {
/*	console.log(action);*/
	switch (action.type) {
		case ON_CLICK_DETAILS_START:
			return {
				...state,
				loadingOnClick: true,
				errorOnClick: "",
				operatorOnClick: "",
			}
		case ON_CLICK_DETAILS_SUCCESS:
			return {
				...state,
				loadingOnClick: false,
				errorOnClick: "",
				operatorOnClick: action.payload,
			}
		case ON_CLICK_DETAILS_FAIL:
			return {
				...state,
				loadingOnClick: false,
				errorOnClick: action.error,
				operatorOnClick: "",
			}
		default:
			return state;
	}
}
